import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { RouteReuseService, TRANSIENT_ROUTES } from '@h5s/design-system';

/**
 * Registra la route reuse strategy dell'applicazione insieme all'elenco di rotte transitorie che
 * la governa: `RouteReuseService` legge `TRANSIENT_ROUTES`, quindi i due provider devono sempre
 * essere registrati insieme.
 *
 * @param transientRoutes rotte senza tab, il cui componente non viene mai mantenuto in memoria.
 * Il confronto è esatto sul path normalizzato: slash iniziale, querystring e slash finale non
 * sono significativi.
 * @returns i provider di route reuse pronti per `ApplicationConfig`.
 */
export function provideRouteReuse(transientRoutes: readonly string[]): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: RouteReuseStrategy, useClass: RouteReuseService },
    { provide: TRANSIENT_ROUTES, useValue: transientRoutes },
  ]);
}
